import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial for the local business owner finder?",
  answer: 'Every new account gets free credits to test our local business owner finder before committing to a paid plan. Search local businesses, find business owner contacts, and launch outreach — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'What data does the local business owner finder return?',
  answer: 'Our local business owner finder returns the owner name, verified email, direct phone, title, LinkedIn profile, business details, and 50+ additional fields for comprehensive outreach.'
}, {
  question: 'How do I find business owner emails for a specific industry?',
  answer: 'You can easily filter our database by industry and location. The search results will include verified owner emails and direct contact information for the decision-makers in that specific sector.'
}, {
  question: 'Can I find local business owners in bulk?',
  answer: 'Yes. Your search can return thousands of results at once. You can then export these business owner contacts or launch an email sequence directly from our platform.'
}, {
  question: 'Does the owner finder integrate with my CRM?',
  answer: 'Absolutely. You can sync your local business owner contacts directly to Salesforce or HubSpot, or download them as a CSV file to import into any other system.'
}];
export function OwnerFinderFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-5885">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5886">
        <div className="text-center mb-10" data-id="element-5887">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-5888">
            Frequently asked <span className="text-blue-600" data-id="element-5889">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-5890">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-5891">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-5892">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-5893">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-5894" />
                </button>
                <AnimatePresence data-id="element-5895">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-5896">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-5897" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}